const AutoCadData = [
  {
    core: [
      {
        id: "1",
        name: "AutoCAD Drawing Task",
        karma: "100",
        description:
          "Create a simple image in AutoCAD using your perspective and dimensions skills. The image can be of anything you choose, but must include at least two different shapes and dimensions. When you are finished, save your drawing as a PDF file and submit it to the designated channel using the hashtag #cl-civil-ac-basicdraw to earn 100 karma points.",
        link: "https://www.youtube.com/watch?v=2LumoE9KjoY",
        inner_description: "After finishing the drawing task, upload your drawing as a PDF file to the designated civil-engineering channel and include the hashtag #cl-civil-ac-basicdraw in your submission message to earn karma points.",
        example:
          "#cl-civil-ac-basicdraw Hey! I’ve completed the AutoCAD drawing task. Here is the PDF file of my drawing.",
      },

      {
        id: "2",
        name: "Plan and Elevation",
        karma: "100",
        description:
          "The task at hand requires you to watch a video explaining a drawing, and then draw a floor plan and elevation from your own perspective of the explained drawing.",
        link: "https://www.youtube.com/watch?v=kzBfJfLI0H8",
        inner_description:
          "After finishing the drawing task, upload your drawing as a PDF file to the designated civil-engineering channel and include the hashtag #cl-civil-ac-floorelevation in your submission message to earn karma points.",
        example:
          "#cl-civil-ac-floorelevation Hey! I’ve completed drawing the plan and elevation. Here’s is the PDF file of my drawing.",
      },
      {
        id: "3",
        name: "Home Model Creation",
        karma: "200",
        description:
          "Your task is to create a model of your home based on your perspective. You will need to draw a plan and an elevation of your home. The dimensions of the model can be assumed to adhere to standard values. ",
        link: "https://youtube.com/watch?v=TEf3lDX4VCk&t",
        inner_description:
          "After finishing the drawing task, upload your drawing as a PDF file to the designated civil-engineering channel and include the hashtag #cl-civil-ac-modelhome in your submission message to earn karma points",
        example:
          "#cl-civil-ac-modelhome Hey! I’ve completed drawing the plan and elevation. Here’s is the PDF file of my drawing.",
      },
    ],
  },
]

export default AutoCadData
